module.exports = __webpack_public_path__ + "static/media/6-10.ccbdc3d2.mp3";